<template>
  <div class="wraper">
    <swiper :options="swiperOption">
      <!-- slides -->
      <swiper-slide v-for="item in items" :key="item.id">
        <a :href="item.url"><img class="item-img" :src="GLOBAL.IMG + item.image" /></a>
      </swiper-slide>

      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "vueSwpier",
  components: {
    swiper,
    swiperSlide
  },
  props:['items','autoplay'],
  data() {
    return {
      swiperOption: {
        pagination: ".swiper-pagination",
        loop:true,
        autoplay : this.autoplay,
      },
    };
  },
  
};
</script>
<style lang="scss" scoped>
.wraper {
  height: 0;
  width: 100%;
  padding-bottom: 37.5%;
  overflow: hidden;
  background-color: #ccc;
  .item-img {
    width: 100%;
  }
  ::v-deep .swiper-pagination-bullet-active
    {background-color:#fff;}
}
</style>